document.addEventListener('DOMContentLoaded', () => {
  const cartBubble = document.querySelector('#cart-icon-bubble');

  // Update badge whenever Shopify triggers the cart update event
  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail.cart;
    if (cart && cartBubble) {
      cartBubble.textContent = cart.item_count;
      cartBubble.dataset.cartCount = cart.item_count;
      cartBubble.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
    }
  });

  // Fallback: poll cart.item_count every 1 second (only if event doesn't exist)
  setInterval(() => {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (cartBubble && parseInt(cartBubble.dataset.cartCount) !== cart.item_count) {
          cartBubble.textContent = cart.item_count;
          cartBubble.dataset.cartCount = cart.item_count;
          cartBubble.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
        }
      });
  }, 1000);
});